import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import Wallets from '../views/Wallets.vue'
import WalletDetail from '../views/WalletDetail.vue'
import Clients from '../views/Clients.vue'
import Settings from '../views/Settings.vue'
import Transactions from '../views/Transactions.vue'
import Rates from '../views/Rates.vue'
import Coins from '../views/Coins.vue'
import Exchanges from '../views/Exchanges.vue'
import Expenses from '../views/Expenses.vue'
import ExpenseTypes from '../views/ExpenseTypes.vue'
import Investors from '../views/Investors.vue'
import Settlements from '../views/Settlements.vue'
import Users from '../views/Users.vue'
import Roles from '../views/Roles.vue'
import Permissions from '../views/Permissions.vue'
import VersioningConfigs from '../views/VersioningConfigs.vue'
import Versions from '../views/Versions.vue'
import CourierTransfers from '../views/CourierTransfers.vue'
import FinancialReports from '../views/FinancialReports.vue'
import BudgetLines from '../views/BudgetLines.vue'
import BudgetReport from '../views/BudgetReport.vue'
import PnlReport from '../views/PnlReport.vue'
import WalletOperations from '../views/WalletOperations.vue'
import PassiveOperations from '../views/PassiveOperations.vue'

const routes = [
  { path: '/login', component: Login },
  { 
    path: '/', 
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  { 
    path: '/wallets', 
    component: Wallets,
    meta: { requiresAuth: true }
  },
  { 
    path: '/wallets/:id', 
    component: WalletDetail,
    meta: { requiresAuth: true }
  },
  {
    path: '/clients',
    component: Clients,
    meta: { requiresAuth: true }
  },
  { path: '/settings', component: Settings, meta: { requiresAuth: true } },
  { 
    path: '/transactions', 
    component: Transactions,
    meta: { requiresAuth: true }
  },
  { 
    path: '/rates', 
    component: Rates,
    meta: { requiresAuth: true }
  },
  { 
    path: '/coins', 
    component: Coins,
    meta: { requiresAuth: true }
  },
  { 
    path: '/exchanges', 
    component: Exchanges,
    meta: { requiresAuth: true }
  },
  { 
    path: '/expenses', 
    component: Expenses,
    meta: { requiresAuth: true }
  },
  { 
    path: '/expense-types', 
    component: ExpenseTypes,
    meta: { requiresAuth: true }
  },
  { 
    path: '/investors', 
    component: Investors,
    meta: { requiresAuth: true }
  },
  { 
    path: '/settlements', 
    component: Settlements,
    meta: { requiresAuth: true }
  },
  { 
    path: '/users', 
    component: Users,
    meta: { requiresAuth: true }
  },
  { 
    path: '/roles', 
    component: Roles,
    meta: { requiresAuth: true }
  },
  { 
    path: '/permissions', 
    component: Permissions,
    meta: { requiresAuth: true }
  },
  { 
    path: '/versioning-configs', 
    component: VersioningConfigs,
    meta: { requiresAuth: true }
  },
  { 
    path: '/versions', 
    component: Versions,
    meta: { requiresAuth: true }
  },
  {
    path: '/courier-transfers', 
    component: CourierTransfers,
    meta: { requiresAuth: true }
  },
  {
    path: '/financial-reports', 
    component: FinancialReports,
    meta: { requiresAuth: true }
  },
  {
    path: '/pnl-report',
    component: PnlReport,
    meta: { requiresAuth: true }
  },
  {
    path: '/budget-lines',
    component: BudgetLines,
    meta: { requiresAuth: true }
  },
  {
    path: '/budget-report',
    component: BudgetReport,
    meta: { requiresAuth: true }
  },
  {
    path: '/wallet-operations',
    component: WalletOperations,
    meta: { requiresAuth: true }
  },
  {
    path: '/passive-operations',
    component: PassiveOperations,
    meta: { requiresAuth: true }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isAuthenticated = localStorage.getItem('auth_token') !== null

  if (requiresAuth && !isAuthenticated) {
    next('/login')
  } else {
    next()
  }
})

export default router

